import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { apiBaseUrl } from './config'

console.log('✅ Application en cours de démarrage...')
console.log('🔗 API URL:', apiBaseUrl)

const app = createApp(App)

// Configuration d'erreur globale
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue Error:', err)
  console.info('Error Info:', info)
}

app.use(router)

app.mount('#app')
